module.exports = {
      id: "back-icon-usage",
      viewBox: "0 0 7.828 12.828",
      url: "/" + "sprite-f96a299a5e63739e5b36582e48c149a3.svg#back-icon",
      toString: function () {
        return this.url;
      }
    }